<template>
  <div>
    <tradana-opener></tradana-opener>
    <tradana-testimonials></tradana-testimonials>
    <tradana-steps></tradana-steps>
    <tradana-about></tradana-about>
    <tradana-advice></tradana-advice>
    <tradana-faq></tradana-faq>
  </div>
</template>

<script>
import Opener from '@/components/home/Opener.vue'
import Testimonials from '@/components/home/Testimonials.vue'
import Steps from '@/components/home/Steps.vue'
import About from '@/components/home/About.vue'
import Advice from '@/components/home/Advice.vue'
import Faq from '@/components/home/FAQ.vue'

export default {
  name: 'Home',
  components: {
    TradanaOpener: Opener,
    TradanaTestimonials: Testimonials,
    TradanaSteps: Steps,
    TradanaAbout: About,
    TradanaAdvice: Advice,
    TradanaFaq: Faq
  }
}
</script>
